const getBaseTemplatesCategoryConfig = (feSchedulingRevampV2 = false) => {
  const config = {
    candidate_application_received: {
      label: 'Application submission email templates',
      desc: 'Emails sent to the candidate when they submit an application',
      value: 'candidate_application_received',
      view: ['job', 'candidate', 'org'],
    },
    candidate_interview_notice: {
      ...(feSchedulingRevampV2
        ? {
            label: 'Candidate calendar invites',
            desc: 'Calendar invites sent to candidates for their interviews ',
          }
        : {
            label: 'Candidate interview coordination templates',
            desc: 'Emails sent to the candidate for coordination and updates on their manually scheduled interviews',
          }),

      value: 'candidate_interview_notice',
      view: ['sender', 'interview', 'job', 'candidate', 'org'],
    },
    interviewer_notice: {
      ...(feSchedulingRevampV2
        ? {
            label: 'Interviewer calendar invites',
            desc: 'Calendar invites sent to interviewers for their interviews',
          }
        : {
            label: 'Interviewer coordination templates',
            desc: 'Emails sent to the interviewer for coordination and updates on their interviews',
          }),
      value: 'interviewer_notice',
      view: ['sender', 'interview', 'job', 'candidate', 'org'],
    },
    candidate_interview_booking: {
      label: 'Self-schedule email templates',
      desc: 'Emails sent to the candidate for coordination and updates on self-scheduled interviews',
      value: 'candidate_interview_booking',
      view: ['sender', 'interview', 'job', 'candidate', 'org'],
    },
    candidate_adhoc: {
      label: 'Ad-hoc candidate email templates',
      desc: ' Emails sent ad-hoc to the candidate',
      value: 'candidate_adhoc',
      view: ['sender', 'candidate', 'org', 'job'],
    },
    candidate_job_stage_action_notice: {
      label: 'Email activity templates',
      desc: 'Emails sent to the candidate from the email activity in the interview plan',
      value: 'candidate_job_stage_action_notice',
      view: ['sender', 'candidate', 'org', 'job'],
    },
    candidate_application_rejected: {
      label: 'Rejection email templates',
      desc: 'Emails sent to the candidate when they are rejected from a job',
      value: 'candidate_application_rejected',
      view: ['sender', 'job', 'candidate', 'org', 'survey'],
    },
    candidate_assessment_notice: {
      label: 'Assessment email templates',
      desc: 'Emails sent to the candidate for assessments ',
      value: 'candidate_assessment_notice',
      view: ['sender', 'candidate', 'org', 'job'],
    },
    candidate_offer_notice: {
      label: 'Offer email templates',
      value: 'candidate_offer_notice',
      desc: 'Emails sent to the candidate for offers',
      view: ['sender', 'candidate', 'org', 'job', 'offer'],
    },
    candidate_schedule_notice: {
      label: 'Self-schedule email templates',
      value: 'candidate_schedule_notice',
      desc: 'Emails sent to the candidate for booking slots in self-scheduled interviews',
      view: ['sender', 'schedule_interview', 'job', 'candidate', 'org'],
    },
    survey_notice: {
      label: 'Survey email templates',
      value: 'survey_notice',
      desc: 'Emails sent to the candidate for surveys',
      view: ['sender', 'candidate', 'org', 'job', 'survey', 'user'],
    },
    candidate_availability_notice: {
      label: 'Availability email templates',
      value: 'candidate_availability_notice',
      desc: 'Emails sent to the candidate for availability',
      view: [
        'sender',
        'candidate',
        'org',
        'job',
        'interview',
        'candidate_availability',
      ],
    },
    candidate_interview_confirmation: {
      label: 'Candidate confirmation emails',
      value: 'candidate_interview_confirmation',
      desc: 'Emails sent to candidates for coordination and updates on their interviews',
      view: ['sender', 'interview', 'job', 'candidate', 'org'],
    },
    interviewer_interview_confirmation: {
      label: 'Interviewer confirmation emails',
      value: 'interviewer_interview_confirmation',
      desc: 'Emails sent to interviewers for coordination and updates on their interviews',
      view: ['sender', 'interview', 'job', 'candidate', 'org'],
    },
  };

  return config;
};

export const getTemplatesCategoryConfig = ({
  feSurvey = false,
  feCandidateAvailability = false,
  feSchedulingRevampV2 = false,
} = {}) => {
  const config = { ...getBaseTemplatesCategoryConfig(feSchedulingRevampV2) };

  if (!feSurvey && config.candidate_application_rejected) {
    config.candidate_application_rejected = {
      ...config.candidate_application_rejected,
      view: config.candidate_application_rejected.view.filter(
        (v) => v !== 'survey'
      ),
    };
  }

  if (!feCandidateAvailability && config.candidate_availability_notice) {
    delete config.candidate_availability_notice;
  }

  return config;
};

export const templatesCategoryConfig = getBaseTemplatesCategoryConfig();

/**
 * Template categories whose body is delivered as a calendar-invite description.
 * Calendar providers strip inline styling (font family/size, etc.), so font
 * controls must stay OFF for these — offering them would format text that gets
 * discarded on send. Shared by the template forms and the send composer.
 */
export const CALENDAR_INVITE_CATEGORIES = [
  'candidate_interview_notice',
  'interviewer_notice',
];
